<template>
    <div style="height:100%;width:100%;">   
        <van-row 
            type="flex" 
            style="height:100%"
          v-if="root.device!='phone'"
          :class="[root.device=='ipad'&&'mipad']"
            class="device_pc"
        >
            <van-col flex="1">
                <van-row type='flex' rank='y' style="height:100%;" >
                    <van-col style="margin-top:-0.626vw" flex="1.5">
                    <div class='wrapper'  >
                        <cusbox txt="店铺客流与销售额"> 
                        <div class="tablewrapper" v-if="storePassengerFlowAndSalesShow">             
                            <char1 :ref="time" :data="char1_data" :datelist="datelist" />
                        </div>     
                        <dv-loading v-else>Loading...</dv-loading>
                        </cusbox>
                    </div>
                    </van-col>
                    <van-col flex="2">
                        <div class='wrapper'>
                        <cusbox txt="本月店铺明星产品 TOP20"> 
                        <div class="tablewrapper">             
                        <itemlist 
                            v-if="starProductsOfThisMonthShow"
                            :count='8'
                            :columns='columns1'
                            :data='data1'                    
                        >
                            <template slot='img' slot-scope="{data}">                          
                                    <img class="icon"   :src='data.pics'>                         
                            </template>
                        </itemlist>
                        <dv-loading v-else>Loading...</dv-loading>
                        </div>     
                        </cusbox>
                    </div>
                    </van-col>
                </van-row>
            </van-col>
            <van-col flex="1">
                    <van-row type='flex' rank='y' style="height:100%;" >
                    <van-col flex="2.5">
                    <div class='wrapper' v-if="commodityDetailsShow">
                        <bg color="#091751">
                        <div  slot="row1" flex="1">
                            <tab 
                                :data="mdata"
                                @change='tabchange'
                            />
                        </div>
                        <div slot="row2"  class="bg-row2">
                            <lb :data="lbdata" />
                        </div>
                        </bg>
                    </div>
                    <dv-loading v-else>Loading...</dv-loading>
                    </van-col>
                    <van-col flex="2">
                        <div class='wrapper'>
                        <cusbox txt="近30日销售趋势">                  
                            <char2 v-if="salesTrendShow" ref="char2" :data="char2_data" :datelist="datelist2" />
                            <dv-loading v-else>Loading...</dv-loading>
                        </cusbox>
                    </div>
                    </van-col>
                </van-row>
            </van-col>
            <van-col flex="1">
                <van-row type='flex' rank='y' style="height:100%;">
                    <van-col style="margin-top:-0.626vw" flex="1">
                    <div class='wrapper'  >
                        <cusbox txt="店铺实时客流 (模拟)"> 
                            <van-row class="igroups" type='flex'>             
                                <div flex="1" v-for="(item, index) in real_data" :key="index">
                                    <img class="iimg" :src="item.pics"/> 
                                </div>
                            </van-row>
                        </cusbox>
                    </div>
                    </van-col>
                    <van-col flex="3">
                        <div class='wrapper'>
                        <cusbox txt="本月店铺热力分析 (模拟)"> 
                            <van-row type="flex"  style="flex-direction: column;height:100%">
                                <van-row class="igroups2" type='flex' flex='2'>                         
                                    <div flex="1" v-for="(item, index) in shopimgs" :key="index">
                                        <img class="iimg" :src="item.pics"/> 
                                    </div>
                                </van-row>
                                <van-row flex='5'>
                                    <char3 ref="char3" :data="char3_data" :datelist="datelist3" />
                                </van-row>                       
                            </van-row>
                        </cusbox>
                    </div>
                    </van-col>
                </van-row>
            </van-col>
        </van-row>





       <mobile class="device_phone ppd notransform" v-else>
                <div class="moblieline">
                 <div class='wrapper' v-if="commodityDetailsShow">
                        <bg color="#091751">
                        <div  slot="row1" flex="1">
                            <tab 
                                :data="mdata"
                                @change='tabchange'
                            />
                        </div>
                        <div slot="row2"  class="bg-row2">
                            <lb :data="lbdata" />
                        </div>
                        </bg>
                    </div>
                    <dv-loading v-else>Loading...</dv-loading>
                </div>

                <div  class="moblieline">
                     <cusbox txt="店铺客流与销售额"> 
                        <div class="tablewrapper" v-if="storePassengerFlowAndSalesShow">             
                            <char1 :ref="time" :data="char1_data" :datelist="datelist" />
                        </div>
                        <dv-loading v-else>Loading...</dv-loading>     
                     </cusbox>
                </div>
                
                 <div class="moblieline h400">
                      <cusbox txt="本月店铺明星产品 TOP20"> 
                        <div class="tablewrapper">             
                        <itemlist 
                            v-if="starProductsOfThisMonthShow"
                            :count='8'
                            :columns='cols_1'
                            :data='data1'                    
                        >
                            <template slot='img' slot-scope="{data}">                          
                                    <img class="icon"   :src='data.pics'>                         
                            </template>
                        </itemlist>
                        <dv-loading v-else>Loading...</dv-loading>
                        </div>     
                    </cusbox>
                </div>
                <div  style="height:250px;margin-top:10px;">
                    <cusbox txt="近30日销售趋势">                  
                            <char2 v-if="salesTrendShow" ref="char2" :data="char2_data" :datelist="datelist2" />
                            <dv-loading v-else>Loading...</dv-loading>
                    </cusbox>
                </div>
               <div  style="height:150px;margin-top:10px;">
                       <cusbox txt="店铺实时客流 (模拟)"> 
                            <van-row class="igroups" type='flex'>             
                                <div flex="1" v-for="(item, index) in real_data" :key="index">
                                    <img class="iimg" :src="item.pics"/> 
                                </div>
                            </van-row>
                        </cusbox>
                </div>
                <div  class="moblieline h550">
                        <cusbox txt="本月店铺热力分析 (模拟)"> 
                            <van-row type="flex"  style="flex-direction: column;height:100%">
                                <van-row class="igroups2" type='flex' flex='2'>                         
                                    <div flex="1" v-for="(item, index) in shopimgs" :key="index">
                                        <img class="iimg" :src="item.pics"/> 
                                    </div>
                                </van-row>
                                <van-row flex='5'>
                                    <char3 ref="char3" :data="char3_data" :bwidth='6' :datelist="datelist3" />
                                </van-row>                       
                            </van-row>
                        </cusbox>
                </div>
          </mobile>
    </div>
</template>
<script>
import cusbox from "@/components/vip/cusbox"
import itemlist from "@/components/cuscom/itemlist"
import char1 from "../common/report/char1"
import char2 from "../common/report/char2"
import char3 from "../common/report/char3"
import bg from "../common/other/bg.vue"
import tab from "../common/other/tab.vue"
import lb from "../common/other/lb.vue"
import mobile from "../common/mobile.vue";
import {cols_1} from "./device/phone_column.js"
export default {
    inject: ['mainRoot','root'],
   
    components:{
        cusbox,
        itemlist,
        char1,
        char2,
        bg,
        tab,
        lb,
        char3,
        mobile
    },    
    methods:{
       
    },    
    data(){
        return {
             cols_1,
             mdata:{
                 data1:{value1:'0',value2:'0'},
                 data2:{value1:'0',value2:'0'},
                 data3:{value1:'0',value2:'0'},
                 data4:{value1:'0',value2:'0'},
                 data5:{value1:'0',value2:'0'},
                 data6:{value1:'0',value2:'0'}
             },
             api:this.$apis['bigoperation'],
             columns1:[
                {
                    title:"排名",
                    key:'rank',                   
                    align:"center",                   
                    width:'2.5vw',                   
                },
                {
                    title:"图片",
                    key:'pics',
                    width:'3vw',
                    slot:'img'  ,
                     align:"center",          
                },
                {
                    title:"货号",
                    key:'goodsNo' ,
                     align:"center",    
                },
                 {
                    title:"品类",
                    key:'rootcategory',
                     width:'4vw',
                          align: "center"    
                },                
                {
                    title:"销售件数",
                    key:'saleNum',
                    align:"center"      
                },               
                {
                    title:"销售金额",
                    key:'saleMoney' ,
                     align:"center",    
                }  
            ],
            data1:[],
            lbdata:[{orderNum:"",money:"",guideName:""}],
            real_data:[],
            shopimgs:[],
            char1_data:{},
            char2_data:{},
            char3_data:{},
            querydata:{channelId:this.$route.params.id},
            datelist:[],
            datelist2:[],
            datelist3:[],
            changeindex:0,
            time:'',
            storePassengerFlowAndSalesShow:false,
            starProductsOfThisMonthShow:false,
            commodityDetailsShow:false,
            salesTrendShow:false
        }
    },
    watch:{
        '$route'(shop){          
            this.querydata.channelId=shop.params.id
            this.getdata2()
        }
    },
    mounted(){ 
        this.mainRoot.$data.openShops=true;
        this.getdata()
        this.getdata2()
        
      
    },
    
    methods:{
        getdata2(){
              //中间今日销售额之类的数据
            this.api.commodityDetails({...this.querydata,type:this.changeindex+1}).then(res=>{
               // this.mdata=res.data
               this.commodityDetailsShow = true
               this.mdata.data1.value1=res.data.list[0].saleTotal
               this.mdata.data2.value1=res.data.list[0].unitPrice
               this.mdata.data3.value1=res.data.list[0].saleNum
               this.mdata.data4.value1=res.data.list[0].saleOnWay
               this.mdata.data5.value1=res.data.list[0].regularGoodsNum
               this.mdata.data6.value1=res.data.list[0].saleGoodsNum
               
            })
             this.$nextTick(()=>{
                //本月明星产品top20
                this.api.starProductsOfThisMonth(this.querydata).then(res=>{   
                    this.starProductsOfThisMonthShow = true
                    let that = this
                    setTimeout(function(){
                        that.data1=res.data.list;
                    },0)        
                })
                //店铺客流与销售额
                this.api.storePassengerFlowAndSales(this.querydata).then(res=>{
                    // debugger
                    var obj={comeIn:[],date:[],fittingNum:[],past:[],saleTotal:[]}
                    for(var i=0;i<res.data.list.length;i++){
                        obj.comeIn.push(res.data.list[i].comeIn)
                        // obj.date.push(res.data.list[i].date)
                         obj.date.push(res.data.list[i].date)
                        obj.fittingNum.push(res.data.list[i].fittingNum)
                        obj.past.push(res.data.list[i].past)
                        obj.saleTotal.push(res.data.list[i].saleTotal)
                    }
                    this.storePassengerFlowAndSalesShow = true
                    let that = this
                    setTimeout(function(){
                        // debugger
                        that.datelist=obj.date||[]
                        that.char1_data=obj
                        
                    },0)
                    
                }) 
                //近30日销售趋势
                this.api.salesTrend(this.querydata).then(res=>{
                    var obj={date:[],saleTotal:[]}
                     for(var i=0;i<res.data.list.length;i++){
                        obj.date.push(res.data.list[0].date)
                        obj.saleTotal.push(res.data.list[i].saleTotal)
                    }
                    this.salesTrendShow = true
                    let that = this
                    setTimeout(function(){
                        that.datelist2=obj.date
                        that.char2_data=obj
                    },0)
                    
                     
                })
                //中间滚动文字
                this.api.bigOrderNotification(this.querydata).then(res=>{
                    this.lbdata=res.data.list
                })
                //店铺实时客流
                this.api.get5().then(res=>{
                    this.real_data=res.data.list
                })
                //本月店铺热力分析（图片）
                this.api.get6().then(res=>{
                    this.shopimgs=res.data.list
                })
                //本月店铺热力分析（图表）
                this.api.get7().then(res=>{
                    var obj={area:[],data1:[],data2:[],data3:[]}
                    for(var i=0;i<res.data.list.length;i++){
                        // obj.area.push((i+1)+"")
                        obj.data1.push(res.data.list[i].data1)
                        obj.data2.push(res.data.list[i].data2)
                        obj.data3.push(res.data.list[i].data3)
                    }
                     this.char3_data=obj
                     this.datelist3=["A区","B区","C区","D区","E区","F区","G区"]
                })
            })
        },
        getdata(){
          //门店列表
            this.api.bigStore().then(res=>{
                this.mainRoot.$data.shoplist=res.data.list;    
            })
           
        },
        tabchange(index){  
            if(this.changeindex==index){
                return
            }
            this.changeindex=index
            this.time=new Date().getTime()
            let that=this
            that.getdata2()
        }
    }
}
</script>
<style lang="scss" scoped>
  @import './device/pc.scss';
  @import './device/phone.scss';
.van-row--flex {
    flex-wrap: initial;
  }

</style>